import { render, staticRenderFns } from "./WarningLabUnPublish_Data.vue?vue&type=template&id=dad5adc8&scoped=true"
import script from "./WarningLabUnPublish_Data.vue?vue&type=script&lang=js"
export * from "./WarningLabUnPublish_Data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad5adc8",
  null
  
)

export default component.exports